export function breachAdd(pic, comment, callback) {
	return {
    type: 'BREACH_ADD',
		payload: {
			pic: pic,
      comment: comment,
		},
		callback: callback,
	}
};
